var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 44,
    viewBox: "0 0 52 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 22V42.25",
    stroke: "#767676",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8775 36.3775C47.072 35.1811 48.8057 33.288 49.8047 30.9969C50.8038 28.7058 51.0115 26.1473 50.395 23.7251C49.7785 21.3028 48.3729 19.1549 46.4 17.6203C44.4272 16.0856 41.9995 15.2516 39.5 15.25H36.665C35.984 12.6158 34.7146 10.1703 32.9524 8.09723C31.1902 6.02422 28.9809 4.37766 26.4908 3.28137C24.0006 2.18507 21.2943 1.66756 18.5753 1.76774C15.8563 1.86791 13.1954 2.58318 10.7927 3.85975C8.38993 5.13632 6.30783 6.94098 4.70293 9.13806C3.09803 11.3351 2.01209 13.8675 1.52674 16.5446C1.04139 19.2218 1.16927 21.9742 1.90076 24.5948C2.63226 27.2155 3.94833 29.6362 5.75003 31.675",
    stroke: "#767676",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 31L26 22L17 31",
    stroke: "#767676",
    strokeWidth: 2.1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.7ad71677ae864e48209a179198810c70.svg";
export { ForwardRef as ReactComponent };